import { Injectable } from '@angular/core';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor(
  ) { 
  }

  trackClickEvent(
    eventName: string = 'event', 
    eventType: string,
    eventDescription: string, 
    eventLabel?: string,
    eventCategory?: string, 
    eventValue?: number,
    fromNative?: boolean
    ) {
    gtag(eventName, 'search', { levelName: `${eventType}` });
  }

}
